"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarType = exports.WorkspaceMemberType = exports.WorkspaceMemberRoleDisplayName = exports.ClipUploadFailureReason = exports.ClipStatus = exports.ClipType = exports.ClipListFilter = exports.EndpointType = exports.Stage = exports.ClipSourceLabels = exports.WorkspaceMemberRole = exports.ClipSource = exports.FilteredLabel = exports.FilteredType = void 0;
// _DEPRECATE_ #1267
var FilteredType;
(function (FilteredType) {
    FilteredType["all"] = "all";
})(FilteredType || (exports.FilteredType = FilteredType = {}));
// _DEPRECATE_ #1267
var FilteredLabel;
(function (FilteredLabel) {
    FilteredLabel["all"] = "All sources";
})(FilteredLabel || (exports.FilteredLabel = FilteredLabel = {}));
var ClipSource;
(function (ClipSource) {
    ClipSource["iOSPhotosLibrary"] = "iOSPhotosLibrary";
    ClipSource["app"] = "app";
    ClipSource["web"] = "web";
    ClipSource["desktop"] = "desktop";
    ClipSource["desktopSync"] = "desktopSync";
    ClipSource["dropbox"] = "dropbox";
    ClipSource["transferred"] = "transferred";
    ClipSource["instagram"] = "instagram";
    ClipSource["googleDrive"] = "googleDrive";
    ClipSource["vimeo"] = "vimeo";
    ClipSource["smugmug"] = "smugmug";
    ClipSource["box"] = "box";
    ClipSource["frameio"] = "frameio";
    ClipSource["flickr"] = "flickr";
    ClipSource["piction"] = "piction";
    ClipSource["sftp"] = "sftp";
    ClipSource["sharepoint"] = "sharepoint";
    ClipSource["sharePoint"] = "sharePoint";
    ClipSource["starchive"] = "starchive";
    ClipSource["quickconnect"] = "quickconnect";
    ClipSource["s3"] = "s3";
    ClipSource["lightroom"] = "lightroom";
    ClipSource["egnyte"] = "egnyte";
    ClipSource["brandfolder"] = "brandfolder";
    ClipSource["webdam"] = "webdam";
    ClipSource["widen"] = "widen";
    ClipSource["bynder"] = "bynder";
    ClipSource["jsonMetadata"] = "jsonMetadata";
    ClipSource["publicApi"] = "publicApi";
    ClipSource["canto"] = "canto";
    ClipSource["csv"] = "csv";
    ClipSource["openAsset"] = "openAsset";
    ClipSource["photoshelter"] = "photoshelter";
})(ClipSource || (exports.ClipSource = ClipSource = {}));
var WorkspaceMemberRole;
(function (WorkspaceMemberRole) {
    WorkspaceMemberRole["sysadmin"] = "sysadmin";
    WorkspaceMemberRole["admin"] = "admin";
    WorkspaceMemberRole["member"] = "member";
    WorkspaceMemberRole["commenter"] = "commenter";
    WorkspaceMemberRole["guest"] = "guest";
})(WorkspaceMemberRole || (exports.WorkspaceMemberRole = WorkspaceMemberRole = {}));
var ClipSourceLabels;
(function (ClipSourceLabels) {
    ClipSourceLabels["dropbox"] = "Dropbox";
    ClipSourceLabels["app"] = "App";
    ClipSourceLabels["transferred"] = "Transferred";
    ClipSourceLabels["web"] = "Web";
    ClipSourceLabels["desktop"] = "Air for Desktop";
    ClipSourceLabels["desktopSync"] = "Air for Desktop";
    ClipSourceLabels["instagram"] = "Instagram";
    ClipSourceLabels["iOSPhotosLibrary"] = "iOS Photo Library";
    ClipSourceLabels["googleDrive"] = "Google Drive";
    ClipSourceLabels["vimeo"] = "Vimeo";
    ClipSourceLabels["smugmug"] = "SmugMug";
    ClipSourceLabels["box"] = "Box";
    ClipSourceLabels["frameio"] = "Frame.io";
    ClipSourceLabels["flickr"] = "Flickr";
    ClipSourceLabels["piction"] = "Piction";
    ClipSourceLabels["bynder"] = "Bynder";
    ClipSourceLabels["sftp"] = "SFTP";
    ClipSourceLabels["sharepoint"] = "SharePoint";
    ClipSourceLabels["sharePoint"] = "SharePoint";
    ClipSourceLabels["starchive"] = "Starchive";
    ClipSourceLabels["quickconnect"] = "quickconnect";
    ClipSourceLabels["s3"] = "S3";
    ClipSourceLabels["lightroom"] = "Lightroom";
    ClipSourceLabels["egnyte"] = "Egnyte";
    ClipSourceLabels["brandfolder"] = "Brandfolder";
    ClipSourceLabels["webdam"] = "Webdam";
    ClipSourceLabels["widen"] = "Widen";
    ClipSourceLabels["jsonMetadata"] = "JsonMetadata";
    ClipSourceLabels["publicApi"] = "API Integration";
    ClipSourceLabels["canto"] = "Canto";
    ClipSourceLabels["csv"] = "CSV";
    ClipSourceLabels["openAsset"] = "OpenAsset";
    ClipSourceLabels["photoshelter"] = "Photoshelter";
})(ClipSourceLabels || (exports.ClipSourceLabels = ClipSourceLabels = {}));
var Stage;
(function (Stage) {
    Stage["dev1"] = "dev1";
    Stage["dev2"] = "dev2";
    Stage["qa"] = "qa";
    Stage["prod"] = "prod";
})(Stage || (exports.Stage = Stage = {}));
var EndpointType;
(function (EndpointType) {
    EndpointType["accounts"] = "accounts";
    EndpointType["addOns"] = "addOns";
    EndpointType["assets"] = "assets";
    EndpointType["boards"] = "boards";
    EndpointType["clips"] = "clips";
    EndpointType["importer"] = "importer";
    EndpointType["integrations"] = "integrations";
    EndpointType["libraries"] = "libraries";
    EndpointType["members"] = "members";
    EndpointType["permissions"] = "permissions";
    EndpointType["recentlyDeleted"] = "recentlyDeleted";
    EndpointType["savedFilters"] = "savedFilters";
    EndpointType["search"] = "search";
    EndpointType["shorturl"] = "shorturl";
    EndpointType["slack"] = "slack";
    EndpointType["subnav"] = "subnav";
    EndpointType["subscriptions"] = "subscriptions";
    EndpointType["sysadmin"] = "sysadmin";
    EndpointType["sync"] = "sync";
    EndpointType["tags"] = "tags";
    EndpointType["workspaces"] = "workspaces";
    EndpointType["discussions"] = "discussions";
    EndpointType["smartTags"] = "smartTags";
    EndpointType["notifications"] = "notifications";
    EndpointType["items"] = "items";
    EndpointType["forms"] = "forms";
    EndpointType["tasks"] = "tasks";
})(EndpointType || (exports.EndpointType = EndpointType = {}));
var ClipListFilter;
(function (ClipListFilter) {
    ClipListFilter["all"] = "all";
    ClipListFilter["bookmarked"] = "bookmarked";
    ClipListFilter["unuploaded"] = "unuploaded";
})(ClipListFilter || (exports.ClipListFilter = ClipListFilter = {}));
var ClipType;
(function (ClipType) {
    ClipType["video"] = "video";
    ClipType["photo"] = "photo";
    ClipType["livePhoto"] = "livePhoto";
    ClipType["animated"] = "animated";
    ClipType["audio"] = "audio";
    ClipType["nonMedia"] = "nonMedia";
})(ClipType || (exports.ClipType = ClipType = {}));
var ClipStatus;
(function (ClipStatus) {
    ClipStatus["created"] = "created";
    ClipStatus["uploaded"] = "uploaded";
    ClipStatus["transcoding"] = "transcoding";
    ClipStatus["transcoded"] = "transcoded";
    ClipStatus["failed"] = "failed";
    ClipStatus["nonTranscodable"] = "nonTranscodable";
})(ClipStatus || (exports.ClipStatus = ClipStatus = {}));
var ClipUploadFailureReason;
(function (ClipUploadFailureReason) {
    ClipUploadFailureReason["expiredSubscription"] = "Subscription has expired";
    ClipUploadFailureReason["noMoreStorage"] = "Workspace storage is full";
})(ClipUploadFailureReason || (exports.ClipUploadFailureReason = ClipUploadFailureReason = {}));
// These are default roles that are non-workspace specific.
// any future custom roles that a specific workspace will make won't be added here
var WorkspaceMemberRoleDisplayName;
(function (WorkspaceMemberRoleDisplayName) {
    WorkspaceMemberRoleDisplayName["Default"] = "Default";
    WorkspaceMemberRoleDisplayName["Sysadmin"] = "Sysadmin";
    WorkspaceMemberRoleDisplayName["WorkspaceOwner"] = "Workspace Owner";
    WorkspaceMemberRoleDisplayName["Admin"] = "Admin";
    WorkspaceMemberRoleDisplayName["Editor"] = "Editor";
    WorkspaceMemberRoleDisplayName["Commenter"] = "Commenter";
    WorkspaceMemberRoleDisplayName["LibraryOwner"] = "Library Owner";
    WorkspaceMemberRoleDisplayName["LibraryAdmin"] = "Library Admin";
    WorkspaceMemberRoleDisplayName["LibraryEditor"] = "Library Editor";
    WorkspaceMemberRoleDisplayName["LibraryCommenter"] = "Library Commenter";
    WorkspaceMemberRoleDisplayName["Anonymous"] = "Anonymous";
    WorkspaceMemberRoleDisplayName["Viewer"] = "Viewer";
    // ShortUrl
    WorkspaceMemberRoleDisplayName["CanView"] = "Can View";
    WorkspaceMemberRoleDisplayName["CanComment"] = "Can Comment";
    WorkspaceMemberRoleDisplayName["CanCollaborate"] = "Can Collaborate";
    WorkspaceMemberRoleDisplayName["ContentCollection"] = "Content Collection";
})(WorkspaceMemberRoleDisplayName || (exports.WorkspaceMemberRoleDisplayName = WorkspaceMemberRoleDisplayName = {}));
var WorkspaceMemberType;
(function (WorkspaceMemberType) {
    WorkspaceMemberType["sysadmin"] = "sysadmin";
    WorkspaceMemberType["member"] = "member";
    WorkspaceMemberType["libraryMember"] = "libraryMember";
    WorkspaceMemberType["guest"] = "guest";
    WorkspaceMemberType["anonymous"] = "anonymous";
    WorkspaceMemberType["shorturl"] = "shorturl";
    WorkspaceMemberType["default"] = "default";
})(WorkspaceMemberType || (exports.WorkspaceMemberType = WorkspaceMemberType = {}));
var AvatarType;
(function (AvatarType) {
    AvatarType["workspace"] = "workspace";
    AvatarType["account"] = "account";
})(AvatarType || (exports.AvatarType = AvatarType = {}));
//# sourceMappingURL=types.js.map